import {useContext, useEffect} from "react";
import {createPortal} from 'react-dom';
import {AnimatePresence} from "framer-motion";
import {Styled} from "./Animation.styles"
import useLockBodyScroll from "../../../lib/Hooks/useLockBodyScroll";
import {ANIMATION__CONTEXT} from "../../../Context";
import {TRANSITION_DURATION} from "../../../lib/Hooks/useS115";

const EASE = [0.76, 0, 0.24, 1]

/**
 * Brand wipe played between pages: a black panel sweeps in from the left,
 * flashes the logo, then leaves to the right.
 */
const Animation = () => {

    const [isOn] = useContext<any>(ANIMATION__CONTEXT)

    const {setLocked} = useLockBodyScroll();

    useEffect(() => {
        setLocked(!!isOn)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOn])

    return createPortal(
        <AnimatePresence>
            {isOn && (
                <Styled.Wipe
                    key={'page-wipe'}
                    initial={{x: '-100%'}}
                    animate={{
                        x: ['-100%', '0%', '0%', '100%'],
                        transition: {
                            duration: TRANSITION_DURATION / 1000,
                            times: [0, 0.34, 0.6, 1],
                            ease: EASE
                        }
                    }}
                    exit={{opacity: 0, transition: {duration: 0.15}}}
                >
                    <Styled.Logo
                        src={'/S115Logo.png'}
                        alt={'S115'}
                        initial={{opacity: 0, scale: 0.94}}
                        animate={{
                            opacity: [0, 1, 1, 0],
                            scale: [0.94, 1, 1, 1.04],
                            transition: {duration: TRANSITION_DURATION / 1000, times: [0, 0.34, 0.6, 1]}
                        }}
                    />
                </Styled.Wipe>
            )}
        </AnimatePresence>,
        (document.querySelector('body') as HTMLElement)
    )
}
export default Animation
